import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';

export default {
    data() {
        return ({
          token_exists: false,
          user_details: {
            "user_role": '',
            "user_id": '',
          },
          temporaryPost: null,
          temporary_hub_post:null,
          isSubmitting: false,
          isDropdownVisible: false,
          fileName:'',
          topics:[],
          created_by_id:this.created_by,
          portals:[],
          isMaster: false,
          selectedPortals: [],
          selectedMasterPortal: '',
          categories: [],
          selectedPortalId: null,
          selectedTopicId: null,
          selectedVisibility: 'public',
          searchQuery:"",
          errors: {
            voice_description:null,
            voice_name:null,
            audio_file :null,
            portal: null,
            segment: null,
            report_description: null
          },
          users:[],
          selectedUserIds: [],
          portal_users:[],
          cbo_domain:false,
          portal_types:[],
          selectedPortalType:null,
          contactEmail: '',
          payload:{},
        });
      },
    mounted() {
        this.token_exists = get_token();
        this.user_details=get_user_details();
        this.fecthPortalTypes();
        this.fetch_users();
        this.fetchPortals();
    },
    computed: {
        portal_id() {
          return this.$route.params.portal_id;
        },
        isPublic() {
          return this.selectedVisibility === 'public';
        },
        filteredUsers() {
            if (!this.searchQuery) {
              return this.users;
            }
            const query = this.searchQuery.toLowerCase();
            return this.users.filter(user =>
              user.first_name.toLowerCase().includes(query) ||
              user.last_name.toLowerCase().includes(query)
            );
          },
        areAllSelected() {
            const filteredIds = this.filteredUsers.map(user => user.id);
            return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
          },
        filteredPortals() {
            if (!this.searchQuery) {
                return this.portals.filter(portal =>
                    !portal.portal_type || portal.portal_type.name !== 'incident'
                );
            }
            const query = this.searchQuery.toLowerCase();
            return this.portals.filter(portal =>
                (!portal.portal_type || portal.portal_type.name !== 'incident') &&
                portal.name.toLowerCase().includes(query)
            );
        },
        areAllSubPortalsSelected() {
            const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
            return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
        },
    },
  methods: {
    getToken() {
        return get_token();
      },
      fetchPortals() {
        this.isLoading = true;
        $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_portals_api/`,
        method: 'POST',
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(this.payload),

        success: (data) => {
          if(this.user_details.user_role==="admin"){
              this.portals = data.portals;

            }else{
              const portal=data.portals
              this.portals=portal.filter(portal=>portal.has_access=="approved")

            }
        },
        complete: () => {
            this.isLoading = false;
        }
        });
    },
    toggleSelectAll() {
        const filteredIds = this.filteredUsers.map(user => user.id);
        if (this.areAllSelected) {
  
          this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
        } else {
          this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
        }
      },
      toggleSelectAllSubPortals() {
        const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
  
        if (this.areAllSubPortalsSelected) {
            this.selectedPortals = this.selectedPortals.filter(id => !filteredIds.includes(id));
        } else {
            this.selectedPortals = [...new Set([...this.selectedPortals, ...filteredIds])];
        }
    },
      fecthPortalTypes() {
        this.isLoading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_types`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (response) => {
            var status = response.status
            if (status == "success") {
              this.portal_types=response.portal_types
            }
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },
     createPortal() {
     
          if(!this.validationPortalForm()) {
            return;
          }
    
          this.isSubmitting = true;
          const formData = new FormData();
          formData.append('portal_name', this.portal_name);
          formData.append('portal_type',this.selectedPortalType.id)
          formData.append('is_master',this.isMaster)
          formData.append('master_portal_id',this.selectedMasterPortal)
          formData.append('contact_email',this.contactEmail)
          formData.append('is_public', this.isPublic);
          this.selectedPortals.forEach(portal_id => {
            formData.append('sub_portals', portal_id);});
          this.selectedUserIds.forEach(user_id => {
            formData.append('user_id', user_id);
        });
    
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_portal_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              this.$emit('addPortal',response.message)
              $('#portal_modal').modal('hide');
              this.isDropdownVisible = false;
              const portalId = response.portal.id;
              const portalName = response.portal.name;
              const is_public=response.portal.is_public
            
              if (this.selectedPortalType.name ==='publishing'){
                 this.$router.push(`/publish_portal/${portalId}/${portalName}`);   
              } else{
                 this.$router.push(`/view_portal/${portalId}/${portalName}/${is_public}`);
              }
              
            },
            error: (response) => {
              const response_error=response.responseJSON
              Swal.close();
              if(response_error.status==="error"){
                this.errors.portal_name=response_error.message
              }
            },
            complete: () => {
              this.isSubmitting = false;
              this.selectedUserIds=[]
              this.portal_name=''
              this.selectedMasterPortal=null
              this.isMaster=null
              this.selectedPortalType=null
              this.isPublic=true
            }
          });
        },
    fetch_users() {
        return new Promise((resolve) => {
    
            const groupId = this.$route.params.group_id;
        $.ajax({
            type: 'GET',
            data:{group_id:groupId},
            url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
            headers: {
            'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
            this.users = response.data.users_list.filter(user => user.id != this.user_details.user_id);
            resolve();
            },
        });
        });
        },
    validationPortalForm() {
        this.errors = {};
        let valid = true;

        if (!this.portal_name) {
        this.errors.portal_name = 'Portal name is required';
        valid = false;
        }

        return valid;
    },
    addPortalMembers() {
        if (this.selectedUserIds.length === 0) {
            this.errors.user_ids = "Please select at least one member.";
            return;
        }
        $('#portal_member_modal').modal('hide');
        },
        confirmSelectedPortals() {
        $('#select_portals_modal').modal('hide');
        },    
  },
}